// extracted by mini-css-extract-plugin
export default {"container":"Sorted_container__eiZn5","list":"Sorted_list__TCkLM"};